import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getRegisterResultReviewHistories } from 'apis/registerResult';

const useGetRegisterResultReviewHistories = (registerResultId, conds = {}) => {
  const { data: _data, ...rest } = useQuery(
    ['getRegisterResultReviewHistories', registerResultId],
    () => getRegisterResultReviewHistories(registerResultId),
    {
      ...conds,
    }
  );

  const data = useMemo(() => _data?.data ?? [], [_data]);

  return {
    data,
    ...rest,
  };
};

export default useGetRegisterResultReviewHistories;
